<script>
    import {onMount} from 'svelte';
    import Sidebar from '../../components/Sidebar.svelte';
    import {apiCatalogue} from '../../stores/stores';

    onMount(() => {
        fetch("/data/catalogue.json").then(res => {
            res.json().then(catalogue => apiCatalogue.set(catalogue))
        });
    });
</script>

<div class="api-page">
    <div class="sidebar-container">
        <Sidebar/>
    </div>
    <div class="content-container">
        <slot/>
    </div>
</div>

<style type="text/scss">
  .api-page {
    display: flex;
    min-height: calc(100vh - 80px);
    height: 100%;

    .sidebar-container {
      flex: 0 0 200px;
    }

    .content-container {
      flex: 1;
    }
  }
</style>